module.exports = __webpack_public_path__ + "static/img/3.fa06f23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/3.png
// module id = AobJ
// module chunks = 0